import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, MapPin } from "lucide-react"; // Added MapPin
import { PopupModal } from "react-calendly";

// Reworked Hero Component
function Hero() {
  const [openBooking, setOpenBooking] = useState(false);

  return (
    <section className="relative pt-14 md:pt-24 md:pb-10 md:ml-4 overflow-hidden  ">
      {/* Enhanced Background Image - More visible and aspirational */}
      <div className="absolute inset-0 ">
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 mt-8 text-center text-black  text-md md:text-lg font-semibold">
          Valid Until Jan 16, 2026
        </div>
        <picture>
          {/* for mobile */}
          <source
            srcSet="/images/new_year_mobile.webp"
            type="image/webp"
            media="(max-width: 640px)"
          />
          {/* for larger screens */}
          <source
            srcSet="/images/new_year.webp"
            type="image/webp"
            media="(min-width: 641px)"
          />
          <img
            src="/images/new_year.webp" // fallback
            alt="Hero room"
            fetchpriority="high"
            className="w-full min-h-[100vh] md:min-h-0 sm:h-full object-cover object-center"
            width={1920}
            height={1080}
          />
        </picture>
      </div>
      {/* Overlay for text readability */}
      {/* <div className="absolute inset-0 bg-white/30 sm:bg-white/10 md:bg-transparent bg-gradient-to-r from-white/70 via-white/20 to-transparent"></div> */}
      <div className="flex flex-col items-left mx-auto px-4 sm:px-6 lg:px-16 relative z-10">
        <div className="w-full text-center sm:text-left sm:max-w-5xl ">
          {/* Headline - Clearer Benefit & Scope */}
          <motion.h1
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="text-7xl md:text-9xl text-black tracking-tight font-prata text-center sm:text-left"
          >
            New Year, <br />
            <span className="block text-black text-4xl md:text-6xl font-poppins font-light tracking-[0.02rem] lg:tracking-[0.02rem] mb-1">
              New view sale
            </span>
            <span className="block text-[#BE2026] text-2xl lg:text-4xl font-sans tracking-widest font-bold">
              SITEWIDE
            </span>
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 mt-2 sm:mt-12">
              <div className="text-center ">
                <div className="flex flex-row items-baseline gap-1 sm:flex-col sm:items-end sm:gap-0">
                  <div className="text-8xl sm:text-8xl font-bold text-[#BE2026] tracking-[0.1rem] scale-x-110">
                    50%
                  </div>
                  <div className="text-xl font-sans sm:text-2xl text-[#BE2026] font-semibold tracking-[0.1rem]">
                    OFF
                  </div>
                </div>
              </div>
              <div className="bg-black/70 backdrop-blur-sm sm:bg-black rounded-full w-24 h-24 flex items-center justify-center">
                <div className="text-white font-poppins text-center md:text-lg tracking-[0.01rem] text-base sm:text-sm md:text-lg font-semibold ">
                  PLUS
                  <br />
                  EXTRA
                </div>
              </div>
              <div className="text-center">
                <div className="flex flex-row items-baseline gap-1 sm:flex-col sm:items-end sm:gap-0">
                  <div className="text-8xl sm:text-8xl font-bold text-[#BE2026] tracking-[0.1rem] scale-x-110">
                    20%
                  </div>
                  <div className="text-xl font-sans sm:text-2xl text-[#BE2026] font-semibold tracking-[0.1rem]">
                    OFF
                  </div>
                </div>
              </div>
            </div>
            {/* Prominent Savings */}
          </motion.h1>
          {/* Subheadline - Reinforce Key Selling Points (Customer Obsession: Address quality, origin, ease) */}
          {/* <motion.p
						initial={{ opacity: 0, x: -30 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.5, delay: 0.2, ease: "easeOut" }}
						className="mt-4 text-lg md:text-xl text-gray-700"
					>
						Transform your space with premium, handcrafted shades made right
						here in Toronto. Get the perfect fit, style, and price, delivered
						fast.
					</motion.p> */}
          {/* CTAs - Clear Primary and Secondary Actions */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4, ease: "easeOut" }}
            className="
    mt-10
    flex flex-col
    items-center text-center
    gap-4 sm:w-full sm:justify-between
    sm:flex-row sm:items-center  sm:text-left
    max-md:my-10 max-md:px-4
  "
          >
            {/* Shop CTA */}
            <div className="order-1 sm:order-2 w-full max-w-[220px] sm:flex-1 flex justify-center sm:justify-center">
              <Link
                to="/shop"
                className="
        inline-block bg-primary
        text-white
        px-6 py-3
        sm:px-8 sm:py-4
        w-full max-w-xs sm:w-auto
        rounded-lg
        font-semibold text-base sm:text-lg
        text-center
        shadow-md
        hover:bg-primary/90
        transition-all duration-300
        whitespace-nowrap
      "
              >
                Shop Now & Save
              </Link>
            </div>

            {/* Benefits */}
            <div className="order-2 sm:order-1 flex flex-col text-base sm:text-lg text-white sm:text-black font-bold sm:font-normal">
              <div className="flex items-center gap-3 font-semibold mb-2">
                <CheckCircle className="text-white sm:text-[#BE2026]" /> Virtual
                Consult
              </div>
              <div className="flex items-center font-semibold gap-3">
                <CheckCircle className="text-white sm:text-[#BE2026]" />
                Free Swatches
              </div>
            </div>
          </motion.div>
          {/* Trust Badges - More Specific and Trust-Building */}
        </div>
      </div>
      {/* Calendly Popup Modal */}
      <PopupModal
        url="https://calendly.com/offcutshades"
        rootElement={document.getElementById("root")}
        open={openBooking}
        onModalClose={() => setOpenBooking(false)}
        // Use default Calendly styling or pass specific props if needed
      />
    </section>
  );
}

export default Hero;
